import { render, staticRenderFns } from "./ConsignacaoComprovantes.vue?vue&type=template&id=4af8f6ae&"
import script from "./ConsignacaoComprovantes.vue?vue&type=script&lang=js&"
export * from "./ConsignacaoComprovantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports